import queryString from 'query-string'

import { RequestService } from 'services/request.service'

import {
  ForumResponse,
  SectionResponse,
  SectionQueryParams,
  Comment,
  CommentResponse,
  Vote,
  CommentSearchOptions,
  CommentListResponse,
} from 'services/apiTypes/comment.types'

import { emptyTextArea, Delta } from 'types/editor'

import { createQueryParams } from 'utils/queryParams/generic.queryParams'

export class CommentService extends RequestService {
  // Serializes comment from what we get from the api, to what we use in the client
  // TODO - make the api return a resposne so that this isn't neccesary
  private unpackComments = (rootComment: CommentResponse): Comment => {
    return {
      ...rootComment,
      // TODO - NEXT
      // text: !rootComment.text ? emptyTextArea : new Delta(JSON.parse(rootComment.text)),

      // TODO - this needs to be changed
      // This is impossible to type via TS (which I didn't even think was possible)
      children: rootComment.children
        ? // @ts-ignore
          rootComment.children.results
          ? // @ts-ignore
            rootComment.children.results.map((child: any) => this.unpackComments(child))
          : // @ts-ignore
            rootComment.children.map((child: any) => this.unpackComments(child))
        : [],

      nextPage: '',
      activePage: rootComment.page ? rootComment.page : 1,
      featured: rootComment.featured || null,
      type: rootComment.type ? rootComment.type : 0,
    }
  }

  list(commentSearchOptions: CommentSearchOptions = {}) {
    return this.get<CommentListResponse>(`/api/comments/?${queryString.stringify(commentSearchOptions)}`)
  }

  forums() {
    return super.get<ForumResponse>(`/api/comments/forum/`)
  }

  sections(query: SectionQueryParams) {
    const queryString = createQueryParams(query)

    return super.get<SectionResponse>(`/api/comments/${queryString}`)
  }

  // TODO - We should probably remove this functionality at some point
  // hard deleting scares me 😱
  hardDelete(comment: Comment) {
    return super.delete(`/api/comments/${comment.id}/`)
  }

  details(id: number | string, pageNumber: number | string = 1, orderBy: string = '-points'): Promise<Comment> {
    return super
      .get<CommentResponse>(`/api/comments/${id}/?page=${pageNumber}&orderBy=${orderBy}`)
      .then(this.unpackComments)
  }

  update(comment: Comment) {
    // Right now we only support updating the text and archived flags for a comment
    return super
      .patch(`/api/comments/${comment.id}/`, {
        // This text must be stringified for the api
        // TODO - perhaps add validation to the api for this since if we don't stringify this here, it'll still 200
        // Then the comment will just be borked forever
        text: comment.text,
        archived: comment.archived,
        locked: comment.locked,
      })
      .then(this.unpackComments)
  }

  vote(comment: Comment, vote: Vote) {
    return super.put<Vote>(`/api/comments/vote/${comment.id}/`, vote)
  }

  createComment(parentId: number, commentBody: string) {
    // TODO - fix the api resposne on this guy
    return super
      .post<Comment>(`/api/comments/createComment/`, { parent: parentId, text: commentBody })
      .then(this.unpackComments)
  }

  createGlobalNotification(threadId: number, notificationText: string) {
    return super.post(`/api/comments/createGlobalNotification/`, { threadId, text: notificationText })
  }
}

const commentService = new CommentService()

export default commentService
